module.exports = __webpack_public_path__ + "static/media/final 2 copy.cec395af.png";